import Vue from 'vue'
import App from './App.vue'

import ElementUI from 'element-ui'
import syTable from 'sy-assembly'
// import syTable from './lib/index'

import 'element-ui/lib/theme-chalk/index.css'
import './styles/index.scss'

// 自定义组件
// import syTable from './lib/index'


Vue.use(syTable);
Vue.use(ElementUI);

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js